import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/BannerHome.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/LazyRender.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/news/NewsList.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/partner/PartnerSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/projectList/ProjectList.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/reviewSection/ReviewSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/serviceSection/ServiceSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/talkSection/TalkSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/team/TeamSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/home-page/about_home_img_1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/icons/availableproject.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/icons/findagent.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/icons/listproperty.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/icons/loadinground.webp");
